import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '/assets/img/bio.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-a974d335"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "block d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "block pt-3 pb-5"
}
const _hoisted_3 = { class: "p-5 m-5 pt-1 pb-1 mt-0 mb-3" }
const _hoisted_4 = ["alt", "src"]
const _hoisted_5 = { class: "text-center fw-bold px-5" }
const _hoisted_6 = {
  key: 0,
  alt: "bio",
  src: _imports_0,
  height: 50
}
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = {
  key: 0,
  class: "d-inline small-text"
}
const _hoisted_9 = {
  key: 1,
  class: "small my-auto"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold block-title text-primary mb-1" }, "Description", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold block-title text-primary mb-1" }, " Marque ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold block-title text-primary mb-1" }, " Origine ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold block-title text-primary mb-1" }, "Ingrédients", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold block-title text-primary mb-1" }, "Conservation", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold block-title text-primary mb-1" }, "Informations nutritionnelles pour 100g", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Énergie", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Matières grasses", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps-4" }, "Dont acides gras saturés", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Glucides", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps-4" }, "Dont sucres", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Fibres", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Protéines", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Sel", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps-4" }, "Dont sodium", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Alcool", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Fruits, légumes et noix", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  id: "open-modal",
  expand: "block"
}, null, -1))

import {
  IonModal,
  IonIcon,
  IonSpinner,
} from '@ionic/vue';
import { close } from 'ionicons/icons';
import { ref, Ref } from 'vue';
import useCurrentShoppingSessionStore from '@/stores/shopping/currentShoppingSessionStore';
import NutriscoreDisplay from '@/components/common/nutriscore/NutriscoreDisplay.vue';
import { Product } from '@/services/flyingBlue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductModalDetail',
  props: {
  isOpen: Boolean,
  productId: {
    type: Number,
    default: 0,
    required: true,
  },
},
  emits: ['closeModal'],
  setup(__props) {

const numberFormat = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

const props = __props;


const store = useCurrentShoppingSessionStore();
const product: Ref<null | Product> = ref(null);
const loading = ref(true);

async function loadProduct() {
  loading.value = true;
  product.value = await store.getProduct(props.productId);
  loading.value = false;
}

function isNotEmpty(prop: any) {
  return prop !== undefined && prop !== null && prop !== '';
}

function hasNutrionnalInfo() {
  if (product.value) {
    return product.value.energy_kj_100g > 0
      || product.value.energy_kcal_100g > 0
      || product.value.fat_100g > 0
      || product.value.satured_fat_100g > 0
      || product.value.carbonhydrate_100g > 0
      || product.value.sugar_100g > 0
      || product.value.fiber_100g > 0
      || product.value.proteins_100g > 0
      || product.value.salt_100g > 0
      || product.value.sodium_100g > 0
      || product.value.alcohol_100g > 0
      || product.value.fruits_vegetables_100g > 0;
  }
  return false;
}

function formatPrice(price : number) {
  if (price > 0) {
    return numberFormat.format(price);
  }
  return '';
}


return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_col = _resolveComponent("ion-col")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonModal), {
      ref: "modal",
      trigger: "open-modal",
      "is-open": __props.isOpen,
      "initial-breakpoint": "1",
      breakpoints: [0, 1],
      onDidDismiss: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeModal', null))),
      onWillPresent: _cache[2] || (_cache[2] = ($event: any) => (loading.value = true)),
      onDidPresent: loadProduct
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, {
          color: "light",
          class: "pt-0 m-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  color: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "icon-only",
                      icon: _unref(close)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(IonSpinner), { name: "crescent" })
            ]))
          : _createCommentVNode("", true),
        (product.value !== null && loading.value == false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("img", {
                      alt: product.value.name,
                      class: "img-fluid",
                      src: product.value.default_image
                    }, null, 8, _hoisted_4)
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_5, _toDisplayString(product.value.name), 1),
              _createVNode(_component_ion_row, { class: "text-center justify-content-center align-items-center gap-2" }, {
                default: _withCtx(() => [
                  _createVNode(NutriscoreDisplay, {
                    class: "d-inline my-2 me-2",
                    height: 60,
                    rating: product.value.nutriscore_grade ?? 'a'
                  }, null, 8, ["rating"]),
                  (product.value.bio)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "text-center justify-content-center align-items-center gap-2" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(formatPrice(product.value.price)), 1),
                  (product.value.weight > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(Number(product.value.weight)?.toFixed(2)) + "kg ", 1))
                    : _createCommentVNode("", true),
                  (product.value.weight == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(product.value.packaging_label), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (isNotEmpty(product.value.pricePerKg) && product.value.pricePerKg > 0)
                ? (_openBlock(), _createBlock(_component_ion_row, {
                    key: 0,
                    class: "justify-content-center nutri-table"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(formatPrice(product.value.pricePerKg)) + " le kilo ", 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (isNotEmpty(product.value.description))
                ? (_openBlock(), _createBlock(_component_ion_row, {
                    key: 1,
                    class: "mx-4 mt-3 border-bottom border-2 pb-3 d-flex flex-column"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _createTextVNode(" " + _toDisplayString(product.value.description), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (isNotEmpty(product.value.brand) || isNotEmpty(product.value.origin))
                ? (_openBlock(), _createBlock(_component_ion_row, {
                    key: 2,
                    class: "mx-4 mt-3 border-bottom border-2 pb-3"
                  }, {
                    default: _withCtx(() => [
                      (isNotEmpty(product.value.brand))
                        ? (_openBlock(), _createBlock(_component_ion_col, { key: 0 }, {
                            default: _withCtx(() => [
                              _hoisted_11,
                              _createTextVNode(" " + _toDisplayString(product.value.brand), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (isNotEmpty(product.value.origin))
                        ? (_openBlock(), _createBlock(_component_ion_col, { key: 1 }, {
                            default: _withCtx(() => [
                              _hoisted_12,
                              _createTextVNode(" " + _toDisplayString(product.value.origin), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (isNotEmpty(product.value.ingredients))
                ? (_openBlock(), _createBlock(_component_ion_row, {
                    key: 3,
                    class: "mx-4 mt-3 border-bottom border-2 pb-3 d-flex flex-column"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _createTextVNode(" " + _toDisplayString(product.value.ingredients), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (isNotEmpty(product.value.storage))
                ? (_openBlock(), _createBlock(_component_ion_row, {
                    key: 4,
                    class: "mx-4 mt-3 border-bottom border-2 pb-3 d-flex flex-column"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14,
                      _createTextVNode(" " + _toDisplayString(product.value.storage), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (hasNutrionnalInfo())
                ? (_openBlock(), _createBlock(_component_ion_row, {
                    key: 5,
                    class: "mx-4 mt-3 border-bottom border-2 pb-3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      _createVNode(_component_ion_row, { class: "col-12 nutri-table" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { class: "col-8 d-flex flex-column gap-2" }, {
                            default: _withCtx(() => [
                              _hoisted_16,
                              _hoisted_17,
                              _hoisted_18,
                              _hoisted_19,
                              _hoisted_20,
                              _hoisted_21,
                              _hoisted_22,
                              _hoisted_23,
                              _hoisted_24,
                              _hoisted_25,
                              _hoisted_26
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, { class: "col-4 d-flex flex-column gap-2" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, _toDisplayString(product.value.energy_kj_100g) + " kJ / " + _toDisplayString(product.value.energy_kcal_100g) + " kcal", 1),
                              _createElementVNode("div", null, _toDisplayString(product.value.fat_100g) + "g", 1),
                              _createElementVNode("div", null, _toDisplayString(product.value.satured_fat_100g) + "g", 1),
                              _createElementVNode("div", null, _toDisplayString(product.value.carbonhydrate_100g) + "g", 1),
                              _createElementVNode("div", null, _toDisplayString(product.value.sugar_100g) + "g", 1),
                              _createElementVNode("div", null, _toDisplayString(product.value.fiber_100g) + "g", 1),
                              _createElementVNode("div", null, _toDisplayString(product.value.proteins_100g) + "g", 1),
                              _createElementVNode("div", null, _toDisplayString(product.value.salt_100g) + "g", 1),
                              _createElementVNode("div", null, _toDisplayString(product.value.sodium_100g) + "g", 1),
                              _createElementVNode("div", null, _toDisplayString(product.value.alcohol_100g) + "% vol", 1),
                              _createElementVNode("div", null, _toDisplayString(product.value.fruits_vegetables_100g) + "g", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-open"]),
    _hoisted_27
  ], 64))
}
}

})